import apiClient from '@/services/axios'
import qs from 'qs'

export const shopeeImageAttribute = ({ business_id, channel_code, channel_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/product/query/${channel_id}/draft/image/`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getProductVariantShopee = ({ channel_id, business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `channel/shopee/v2/product/query/${channel_id}/attributes`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getProductBrandShopee = ({ channel_id, business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `channel/shopee/v2/product/query/${channel_id}/brand-list`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getShopeeWarehouseChannelList = ({ channel_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/query/warehouse/${channel_id}`,
    params,
  })
}

export const getWarehouseShopee = ({ channel_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/query/warehouse/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getShopeeDetailChannel = ({ business_id, channel_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getShopeePromotionChannelList = ({ business_id, channel_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/promotion/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getShopeePromotionChannelDetail = ({ business_id, channel_id, promotion_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/promotion/query/${channel_id}/${promotion_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const createShopeePromotionChannel = ({ business_id, channel_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/shopee/v2/promotion/cmd/discount/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateShopeePromotionChannel = ({ business_id, channel_id, promotion_id, data }) => {
  return apiClient({
    method: 'put',
    url: `/channel/shopee/v2/promotion/cmd/discount/${channel_id}/${promotion_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const nonActiveShopeePromotionChannel = ({ business_id, channel_id, promotion_id }) => {
  return apiClient({
    method: 'put',
    url: `/channel/shopee/v2/promotion/cmd/discount/${channel_id}/${promotion_id}/end`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const deleteShopeePromotionChannel = ({ business_id, channel_id, promotion_id }) => {
  return apiClient({
    method: 'delete',
    url: `/channel/shopee/v2/promotion/cmd/discount/${channel_id}/${promotion_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const syncAllShopeePromotionChannel = ({ business_id, channel_id }) => {
  return apiClient({
    method: 'post',
    url: `channel/shopee/v2/promotion/cmd/sync/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data: {
      status: 'all',
      is_init: false,
    },
  })
}

export const syncSingleShopeePromotionChannel = ({ business_id, channel_id, promotion_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/shopee/v2/promotion/cmd/sync/${channel_id}/${promotion_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getShopeeProductChannelList = ({ business_id, channel_id, params }) => {
  return apiClient({
    method: 'get',
    url: `channel/shopee/v2/product/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    params: {
      sort: 'product_status,ASC',
      channel_code: 'shopee_id',
      sales_channel_id: 43,
      business_id,
      ...params,
    },
  })
}

export const getShopeeSyncProcessStatus = ({ business_id, channel_id, request_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/promotion/query/sync/${channel_id}/${request_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const checkShopeeProductChannelEligibleForPromotion = ({ business_id, channel_id, params, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/shopee/v2/promotion/query/${channel_id}/items_available`,
    headers: {
      'Business-Id': business_id,
    },
    params,
    data,
  })
}

export const getShopeeProductChannelListV2 = ({ business_id, workspace_id, channel_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/product/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
  })
}

export const disconnectShopeeIntegration = ({ business_id, channel_id }) => {
  return apiClient({
    method: 'put',
    url: '/channel/shopee/v2/integration/cmd/disconnect',
    headers: {
      'Business-Id': business_id,
    },
    params: { channel_id },
  })
}

export const mappingWarehouseShopeeChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/channel/shopee/v2/shop/cmd/warehouse/map',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const unMappingWarehouseShopeeChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/channel/shopee/v2/shop/cmd/warehouse/unmap',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const checkShopeeProductSyncStatus = ({ business_id, workspace_id, channel_id, request_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/product/query/sync/${channel_id}/${request_id}`,
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    data: { channel_product_id: [] },
  })
}

export const getLatestShopeeProductChannelSyncStatus = ({ channel_id, business_id, workspace_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/product/query/process/sync`,
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    params: {
      channel_id,
    },
    data: {
      channel_product_id: [],
    },
  })
}

export const updateShopeeAutoAcceptPerWarehouse = ({ business_id, channel_id, data }) => {
  return apiClient({
    method: 'put',
    url: `/channel/shopee/v2/shop/cmd/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const deactivateShopeeProductChannel = ({ business_id, channel_id, channel_product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/shopee/v2/product/cmd/${channel_id}/status/deactivate/${channel_product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const activateShopeeProductChannel = ({ business_id, channel_id, channel_product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/shopee/v2/product/cmd/${channel_id}/status/activate/${channel_product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const syncShopeeSingleProductChannel = ({ business_id, channel_id, product_id }) => {
  return apiClient({
    method: 'post',
    url: `/channel/shopee/v2/product/cmd/${channel_id}/sync/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const channelAcceptShopee = ({ workspace_id, business_id, user_id, params }) => {
  return apiClient({
    method: 'put',
    url: `/channel/shopee/v2/order/cmd/state/channel-accept`,
    params,
  })
}
